import React from 'react';
import './BookingsManagement.css';

/**
 * BookingFilters Component - Renders filters for the bookings table
 * @param {Object} props - Component props
 * @param {Object} props.filters - Current filter values
 * @param {Function} props.onFilterChange - Function to handle filter changes
 * @returns {JSX.Element} - Rendered component
 */
function BookingFilters({ filters, onFilterChange }) {
  return (
    <div className="bookings-management__filters">
      <select
        name="status"
        value={filters.status || ''}
        onChange={onFilterChange}
      >
        <option value="">All Statuses</option>
        <option value="Pending">Pending</option>
        <option value="Confirmed">Confirmed</option>
        <option value="Completed">Completed</option>
        <option value="Cancelled">Cancelled</option>
      </select>
      <input
        type="date"
        name="startDate"
        value={filters.startDate || ''}
        onChange={onFilterChange}
        placeholder="Start Date"
      />
      <input
        type="date"
        name="endDate"
        value={filters.endDate || ''}
        onChange={onFilterChange}
        placeholder="End Date"
      />
    </div>
  );
}

export default BookingFilters; 